import { render, staticRenderFns } from "./saldoDevolucao.vue?vue&type=template&id=81d36366&scoped=true&"
import script from "./saldoDevolucao.vue?vue&type=script&lang=js&"
export * from "./saldoDevolucao.vue?vue&type=script&lang=js&"
import style0 from "./saldoDevolucao.vue?vue&type=style&index=0&id=81d36366&prod&scoped=true&lang=css&"
import style1 from "./saldoDevolucao.vue?vue&type=style&index=1&id=81d36366&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d36366",
  null
  
)

export default component.exports